{
    "changePassword": "Change Password",
    "logout": "Logout",
    "about": "About"
}